import { render, staticRenderFns } from "./DossierAutoSaleRowSettings.vue?vue&type=template&id=e4163a60&scoped=true&"
import script from "./DossierAutoSaleRowSettings.vue?vue&type=script&lang=ts&"
export * from "./DossierAutoSaleRowSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4163a60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4163a60')) {
      api.createRecord('e4163a60', component.options)
    } else {
      api.reload('e4163a60', component.options)
    }
    module.hot.accept("./DossierAutoSaleRowSettings.vue?vue&type=template&id=e4163a60&scoped=true&", function () {
      api.rerender('e4163a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierAutoSaleRowSettings.vue"
export default component.exports